import React, { memo } from 'react'
import image from 'assets/images/offers.jpg'
import classNames from 'classnames'
import classes from './DoubleOffer.module.scss'

const DoubleOffer = () => (
  <div className={classNames('d-flex justify-content-between flex-wrap', classes.width)}>
    <a
      rel="noreferrer"
      href="https://www.chapkadirect.fr/index.php?action=produit&id=751&app=cd_twam"
      target="_blank"
      className={classes.offerLink}>
      <div className={classes.blockWithImage}>
        <img className={classes.image} src={image} alt="offer" />
      </div>
    </a>
    <a
      rel="noreferrer"
      href="https://www.chapkadirect.fr/index.php?action=produit&id=751&app=cd_twam"
      target="_blank"
      className={classes.offerLink}>
      <div className={classes.blockWithImage}>
        <img className={classes.image} src={image} alt="offer" />
      </div>
    </a>
  </div>
)

DoubleOffer.propTypes = {}

DoubleOffer.defaultProps = {}

export default memo(DoubleOffer)
